import React from "react";

import CardHeaderLabel from "./CardHeaderLabel";

const YellowDockCard = () => {
  return (
    <div className="flex h-full flex-col gap-4 bg-results-yellow/20 text-foreground">
      <CardHeaderLabel label="Planning" className="text-black" />
      <div className="flex flex-1 flex-col gap-4 px-4 pb-4">
        <div className="rounded-lg border border-foreground/10 bg-background/70 p-4 text-sm">
          <p className="font-semibold">Placeholder content</p>
          <p className="mt-2 text-foreground/70">
            This tray will host the yellow card experience. Switch tabs to verify the segmented control
            and dock behavior.
          </p>
        </div>
        <div className="rounded-lg border border-foreground/10 bg-background/70 p-4 text-sm">
          <p className="font-semibold">Ideas for this card</p>
          <ul className="mt-2 list-disc space-y-1 pl-4 text-foreground/70">
            <li>Summary metrics</li>
            <li>Quick actions</li>
            <li>Status checkpoints</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default YellowDockCard;
